import { DATA_FIELD_KEY_SEPARATOR } from '../constants';

export const getMetaDataFromColumnKey = (key: string) => {
  const [prefix, calculationId, ...eventNameParts] = key.split(DATA_FIELD_KEY_SEPARATOR);
  return { prefix, calculationId, eventName: eventNameParts.join(DATA_FIELD_KEY_SEPARATOR) || undefined };
};
